<template>
    <div class="panel-wrapper">
        <div class="panel-wrapper__title">
            <div>选择户型：</div>
            <div style="color: #56a3a6" @click="reset">清除</div>
        </div>

        <div class="sort-container">
            <div class="form-item sort-container__item"
            v-for="(item, index) in layouts"
            :key="index"
            @click="sort(item.value)">
                <div class="form-item__body">
                    <div :class="['form-item__body_input wrapper radio', filters.layout == item.value ? 'active' : '']">
                        <div class="form-item__body_input_text">{{item.name}}</div>
                        <img mode="aspectFit"
                        class="form-item__body_icon"
                        src="@/assets/icons/circle-check-sharp-solid.svg"
                        :style="{opacity: filters.layout == item.value ? 1 : 0}"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filters'],
        data () {
            return {
                layouts: [
                    {name: '整租单间', value: 'entire'},
                    {name: '整租1室', value: 'entire1'},
                    {name: '整租2室', value: 'entire2'},
                    {name: '整租3室+', value: 'entire3'}
                ]
            }
        },
        methods: {
            sort (value) {
                this.$emit('search', {layout: value})
            },
            reset () {
                this.$emit('search', {layout: ''})
            }
        }
    }
</script>

<style lang="less" scoped>
    .sort-container {
        padding: 10px 0;
    }
    .sort-container__item {
        margin-top: 10px;
        margin-bottom: 0;
    }
</style>

